import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import useCustomLogic from "../../Hooks/UseCustomLogic";
import BuildingBetterContactDialog from "../BuildingBetterContact/BuildingBetterContactDialog";
import { Link as RouterLink } from "react-router-dom";

const CustomBuildingNavBar = ({ selectedTab }) => {
  const { isXs } = useCustomLogic();
  const [isContactOpen, setIsContactOpen] = useState(false);
  return (
    <>
      <Grid container sx={horizontalbarStyle(isXs)}>
        <Grid
          item
          component={RouterLink}
          to="/jaldi-portal/building-better-court-data"
          sx={headerItems(isXs)}
        >
          <Typography
            variant="body1"
            sx={{
              color: selectedTab === "data" && "#FF8278",
              fontSize: isXs ? "13px" : "16px",
            }}
          >
            Data
          </Typography>
        </Grid>

        <Grid
          item
          component={RouterLink}
          to="/jaldi-portal/portal-building-better-court"
          sx={headerItems(isXs)}
        >
          <Typography
            variant="body1"
            sx={{
              color: selectedTab === "about" && "#FF8278",
              fontSize: isXs ? "13px" : "16px",
            }}
          >
            About
          </Typography>
        </Grid>

        <Grid
          item
          component={RouterLink}
          to="/jaldi-portal/building-better-court-method"
          sx={headerItems(isXs)}
        >
          <Typography
            variant="body1"
            sx={{
              color: selectedTab === "method" && "#FF8278",
              fontSize: isXs ? "13px" : "16px",
            }}
          >
            Method
          </Typography>
        </Grid>

        <Grid
          item
          component={RouterLink}
          to="/jaldi-portal/building-better-court-disclaimer"
          sx={headerItems(isXs)}
        >
          <Typography
            variant="body1"
            sx={{
              color: selectedTab === "disclamier" && "#FF8278",
              fontSize: isXs ? "13px" : "16px",
            }}
          >
            Disclamier
          </Typography>
        </Grid>

        <Grid
          item
          component="button"
          type="button"
          sx={headerItems(isXs)}
          onClick={() => setIsContactOpen(true)}
        >
          <Typography
            variant="body1"
            sx={{
              color: selectedTab === "contact" && "#FF8278",
              fontSize: isXs ? "13px" : "16px",
            }}
          >
            Contact
          </Typography>
        </Grid>
      </Grid>
      <BuildingBetterContactDialog
        open={isContactOpen}
        onClose={() => setIsContactOpen(false)}
      />
    </>
  );
};

export default CustomBuildingNavBar;

const headerItems = (isXs) => {
  return {
    color: isXs ? "black" : "#ffffff",
    cursor: "pointer",
    lineHeight: 1,
    border: 0,
    background: "transparent",
    textDecoration: "none",
    fontFamily: "inherit",
    "&:not(:last-child)": {
      borderRight: "1px solid #AAAAAA",
      paddingRight: "10px",
    },
    "&:hover": {
      color: "#FF8278",
    },
  };
};

const mainContainerStyle = {
  height: "80px",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  background: "rgba(255, 255, 255, 0.80)",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.08)",
  backdropFilter: "blur(2px)",
  position: "sticky",
  top: 64,
  zIndex: 2,
};

const horizontalbarStyle = (isXs) => {
  return {
    display: "flex",
    padding: isXs ? "12px 10px" : "12px 40px",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    borderRadius: isXs ? "0px" : "360px",
    background: isXs ? "#DCDCDC" : "#1D1D1D",
    width: isXs ? "100%" : "fit-content",
    // width: "fit-content",
  };
};
